export const SAVE_LIVE_STATUS = "SAVE_LIVE_STATUS";

// Action Creator to set isLive status
export const saveLiveStatus = (isLive: boolean) => {
  // console.log({ isLive });

  return {
    type: SAVE_LIVE_STATUS,
    payload: isLive,
  };
};
